module.exports = __webpack_public_path__ + "img/poi_icon_yelp.51a3baf.png";